<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="18" stroke="currentColor" stroke-width="2"/>
    <circle cx="8" cy="8" r="2" fill="currentColor"/>
    <path d="M3 18L9 12L14 17L18 13L21 16V21H3V18Z" fill="currentColor"/>
  </svg>
</template>
